/* eslint-disable no-undef */
/* global filter_obj */
const $ = jQuery.noConflict();

/* ---------------------------------------------
   FILTER DROPDOWN UI CONTROL
----------------------------------------------*/
$(document).ready(function() {
    const $filterWrap = $('.post-ajax-filter .lg-filter');
    if (!$filterWrap.length) {return;}

    const $filterCols = $('.lg-filter-col');
    const $filterMenus = $('.lg-filter-menu');

    $('.lg-filter-col .lg-filter-item').on('click', function() {
        const $parentCol = $(this).parent();

        $filterCols.not($parentCol).removeClass('active');
        $filterMenus.not($(this).next()).stop().slideUp();

        if ($parentCol.hasClass('active')) {
            $(this).next('.lg-filter-menu').stop().slideUp();
            $parentCol.removeClass('active');
        } else {
            $(this).next('.lg-filter-menu').stop().slideDown();
            $parentCol.addClass('active');
        }
    });

    $('.lg-search').on('click', function() {
        $filterCols.removeClass('active');
        $filterMenus.stop().slideUp();
    });

    $(document).on('click touchstart', function(e) {
        if (!$(e.target).closest('.lg-filter-col, .lg-search').length) {
            $filterCols.removeClass('active');
            $filterMenus.stop().slideUp();
        }
    });

    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $filterCols.removeClass('active');
            $filterMenus.stop().slideUp();
        }
    });
});

/* ---------------------------------------------
   PREPARE FILTER DATA (REUSABLE)
----------------------------------------------*/
function prepare_filter_data_post() {
    const $form = $('.post-ajax-filter form.listing-filter-form');

    return {
        pager: $form.find('#pager').val(),
        posts_per_page: $form.find('[name="posts_per_page"]').val(),
        search_keyword: $form.find('[name="search_text"]').val(),
        sort_value: $form.find('.filter-order').val(),

        product: $form.find('input[name="product"]:checked').map(function() { return this.value; }).get().join(','),
        solution: $form.find('input[name="solution"]:checked').map(function() { return this.value; }).get().join(','),
        type: $form.find('input[name="type"]:checked').map(function() { return this.value; }).get().join(','),

        lg_product_select: $form.find('[name="lg_product_select"]').val(),
        lg_solution_select: $form.find('[name="lg_solution_select"]').val(),
        lg_type_select: $form.find('[name="lg_type_select"]').val(),
    };
}

/* ---------------------------------------------
   SUBMIT EVENT — SINGLE CLEAN HANDLER
----------------------------------------------*/
$('.post-ajax-filter form.listing-filter-form').on('submit', function(event) {
    event.preventDefault();

    render_selected_filters_post();

    const data = prepare_filter_data_post();

    post_filter_data_post(
        data.pager,
        data.posts_per_page,
        data.search_keyword,
        data.sort_value,
        data.product,
        data.lg_product_select,
        data.solution,
        data.lg_solution_select,
        data.type,
        data.lg_type_select,
    );
});

/* ---------------------------------------------
   AUTO RUN AJAX ON PAGE LOAD (ONE TIME)
----------------------------------------------*/
$(window).on('load', function() {
    const data = prepare_filter_data_post();
    post_filter_data_post(
        data.pager,
        data.posts_per_page,
        data.search_keyword,
        data.sort_value,
        data.product,
        data.lg_product_select,
        data.solution,
        data.lg_solution_select,
        data.type,
        data.lg_type_select,
    );
});

/* ---------------------------------------------
   SEARCH INPUT
----------------------------------------------*/
$(document).on('change keydown', '.post-ajax-filter .search-text', function() {
    $('.post-ajax-filter #pager').val(1);
});

$(document).on('click', '.post-ajax-filter .icon-search-2', function(e) {
    e.preventDefault();
    $('.post-ajax-filter #pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

/* ---------------------------------------------
   REMOVE TAG FROM SELECTED FILTER LIST
----------------------------------------------*/
$(document).on('click', '.post-ajax-filter .lg-filter-selected-list .lg-selected', function() {
    const fid = $(this).data('slug');
    $('#' + fid).prop('checked', false);
    $(this).remove();
    $('.post-ajax-filter #pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

/* ---------------------------------------------
   PAGINATION
----------------------------------------------*/
$(document).on('click', '.post-ajax-filter .pagination a.next', function(e) {
    e.preventDefault();
    const pager = Number($('.post-ajax-filter input[name="pager"]').val());
    $('#pager').val(pager + 1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

$(document).on('click', '.post-ajax-filter .pagination a.prev', function(e) {
    e.preventDefault();
    const pager = Number($('.post-ajax-filter input[name="pager"]').val());
    $('#pager').val(pager - 1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

/* ---------------------------------------------
   RESET FILTER
----------------------------------------------*/
$('.post-ajax-filter .reset-filter').on('click', function(e) {
    e.preventDefault();

    const $form = $('.post-ajax-filter form.listing-filter-form');
    $form.find('#pager').val(1);
    $form.find('[name="search_text"]').val('');
    $form.find('select[name="filter_order"] option:first').prop('selected', true);
    $form.find('input[type="checkbox"]').prop('checked', false);

    $form.submit();
});

/* ---------------------------------------------
   CATEGORY & ORDER FILTER
----------------------------------------------*/
$('.post-ajax-filter .filter-order, .post-ajax-filter .cat-filter').on('change', function() {
    $('#pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

$('.post-ajax-filter .lg-filter-apply').on('click', function() {
    $('#pager').val(1);
    $('.post-ajax-filter form.listing-filter-form').submit();
});

/* ---------------------------------------------
   AJAX FUNCTION FOR POSTS
----------------------------------------------*/
function post_filter_data_post(
    pager, posts_per_page, search_keyword, sort_value,
    product, lg_product_select, solution, lg_solution_select, type, lg_type_select,
) {

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: filter_obj.ajax_url,
        data: {
            action: 'fetch_post_list',
            security: filter_obj.nonce,
            pager, posts_per_page, search_keyword,
            solution, lg_solution_select,
            product, lg_product_select,
            type, lg_type_select,
            sort_value,
        },

        beforeSend: function() {
            $('.post-ajax-filter .filter-load-more').show();
            $('.post-ajax-filter .pagination').html('');
            $('.post-ajax-filter .lg-grid-main-row').html('');
        },

        success: function(response) {
            $('.post-ajax-filter .filter-load-more').hide();
            $('.post-ajax-filter .lg-grid-main-row').html(response.data).fadeIn(150);

            $('.post-ajax-filter .pagination').html(response.pagination).show();

            if (response.showing) {
                $('.post-ajax-filter .showing-result').text(response.showing);
            }

            const initslide = Number($('.post-ajax-filter #initslide').val());
            if (initslide === 1) {
                $('html, body').animate({
                    scrollTop: $('.post-ajax-filter').offset().top - 60,
                }, 800);
            }

            $('.post-ajax-filter #initslide').val(1);

            if (response.total_pages) {
                $('input[name="max_pages"]').val(response.total_pages);
            }

            if (response.pager) {
                $('#pager').val(response.pager);
            }
        },

        error: function(error) {
            console.error('AJAX error:', error);
        },
    });
}


function render_selected_filters_post() {
    const $form = $('.post-ajax-filter form.listing-filter-form');
    const $list = $('.post-ajax-filter .lg-filter-selected-list');

    $list.empty(); // reset first

    const groups = [
        { name: 'product', class: 'product-selected' },
        { name: 'solution', class: 'solution-selected' },
        { name: 'type', class: 'type-selected' },
    ];

    groups.forEach(group => {
        $form.find(`input[name="${group.name}"]:checked`).each(function() {
            const val = $(this).val();
            const label = $(this).closest('li').find('label').data('label');

            $list.append(`
                <button class="lg-selected ${group.class} no-btn" 
                        data-slug="${group.name}_${val}">
                    <em class="close-icon"></em>${label}
                </button>
            `);
        });
    });
}
